export default __webpack_public_path__ + "static/senses-4b8fb29b2b75a8088721264537e798cd.png";